module.exports = __webpack_public_path__ + "static/media/Illustration.a466e7c2.svg";